module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921051151_T.23ce61ba.jpg";